module.exports = __webpack_public_path__ + "img/mail-icon-filled.14961c52.svg";